export default __webpack_public_path__ + "static/media/NewArrivals.bc20891a.png";